<section class="container py-5 mt-5 mb-sm-2 mb-lg-3 mb-xl-4 mb-xxl-5">
  <h2 class="h1">{{event?.name}}</h2>
  <div class="row pb-sm-1 pb-md-4">
    <div class="mb-3 mb-md-0"
      [ngClass]="(this.isEventOwner || !this.event?.hasTargetAmountHidden ? 'col-md-8 col-lg-9' : 'col-12')">

      <section class="card bg-secondary border-0 py-1 p-md-2 p-xl-3 p-xxl-4 mb-4">

        <div class="card-body">
          <div class="d-sm-flex align-items-center pb-4 mt-sm-n1 mb-0 mb-lg-1 mb-xl-3">
            <div class="d-flex align-items-center">
              <i class="ai-card text-primary lead pe-1 me-2"></i>
              <h2 class="h4 mb-0">Contributii</h2>
            </div>
            <div class="ms-auto pt-3 pt-sm-0">
              <select [(ngModel)]="filter" (ngModelChange)="onFilterChange()" class="form-select ms-auto">
                <option value="all">Toate contributiile</option>
                <option value="last-week">Ultima saptamana</option>
                <option value="last-month">Ultima luna</option>
              </select>
            </div>
          </div>
          <ng-container *ngIf="contributions">
            <div
              *ngFor="let transaction of filteredContributions | slice: (page - 1) * itemsPerPage : page * itemsPerPage; first as first"
              class="row gx-0 fs-4 fw-normal py-3 border-bottom" [ngClass]="{'border-top': first}">
              <div class="col-8 col-sm-5">
                <div class="fs-sm text-muted mb-2">Data</div>
                <div class="fs-sm fw-medium text-dark"><i class="ai-time me-2 ms-n1"></i>{{transaction.contributedDate |
                  date:
                  'MMM d, y, HH:mm':undefined:'ro'}}</div>
              </div>
              <div class="col-sm-5 order-3 order-sm-2 pt-3 pt-sm-0">
                <div class="fs-sm text-muted mb-2">Nume</div>
                <div class="fs-sm fw-medium text-dark">{{transaction.name}}</div>
              </div>
              <div class="col-4 col-sm-2 order-2 order-sm-3 text-sm-end">
                <div class="fs-sm text-muted mb-2">Contributie</div>
                <div class="fs-sm fw-medium text-dark">{{transaction.amount | number:'1.2-2'}} lei</div>
              </div>
            </div>

            <!-- Pagination-->
            <div *ngIf="filteredContributions?.length" class="d-sm-flex align-items-center pt-4 pt-sm-5">
              <nav class="order-sm-2 ms-sm-auto mb-4 mb-sm-0" aria-label="Orders pagination">
                <ngb-pagination [(page)]="page" [collectionSize]="filteredContributions.length"
                  [pageSize]="itemsPerPage" [maxSize]="5" [directionLinks]="false" [boundaryLinks]="false" [rotate]="true" size="sm"
                  (pageChange)="onPageChanged()" class="d-flex justify-content-center"></ngb-pagination>
              </nav>
            </div>

            <div *ngIf="filteredContributions?.length"
              class="d-flex flex-column flex-sm-row justify-content-between mt-4">
              <a [routerLink]="['/eveniment', eventCode]" class="btn btn-secondary btn-lg mb-3 mb-sm-0"
                role="button">Inapoi</a>
            </div>
          </ng-container>

          <!-- No items -->
          <div *ngIf="contributions?.length === 0" class="card border-0 bg-secondary text-center">
            <svg-icon src="assets/images/illustrations/no-data.svg" svgClass="w-50 h-50 mt-3"></svg-icon>
            <div class="card-body">
              <h4 class="card-title">Nicio inregistrare</h4>
              <p class="card-text">Nu exista contributii. Vrei sa contribui la acest eveniment?</p>
              <a [routerLink]="['/eveniment', eventCode]" class="btn btn-secondary w-100 w-sm-auto mb-2 mb-sm-0"
                role="button">Inapoi</a>
              <a [routerLink]="['/contributie', eventCode]"
                [class.disabled]="!event?.isStarted || event?.status !== 'Active' || !hasContributionsEnabled || event?.isSuspended || (isCorporateUser$ | async)"
                class="btn btn-primary w-100 w-sm-auto ms-sm-2">Contribuie</a>

            </div>
          </div>

          <!-- No filter results template -->
          <div *ngIf="contributions?.length > 0 && filteredContributions?.length === 0"
            class="card border-0 bg-secondary text-center">
            <svg-icon src="assets/images/illustrations/no-search-results.svg" svgClass="w-50 h-50 mt-3"></svg-icon>
            <div class="card-body">
              <h4 class="card-title">Nicio inregistrare</h4>
              <p class="card-text">Ne pare rau, nu a fost gasit niciun rezultat care sa corespunda cautarii.</p>
              <a [routerLink]="['/eveniment', eventCode]" class="btn btn-secondary w-100 w-sm-auto mb-2 mb-sm-0"
                role="button">Inapoi</a>
              <a [routerLink]="['/contributie', eventCode]"
                [class.disabled]="!event?.isStarted || event?.status !== 'Active' || !hasContributionsEnabled || event?.isSuspended || (isCorporateUser$ | async)"
                class="btn btn-primary w-100 w-sm-auto ms-sm-2">Contribuie</a>
            </div>
          </div>

          <!-- Loading template -->
          <div *ngIf="!contributions">
            <div *ngFor="let item of [].constructor(itemsPerPage); last as last" [ngClass]="{'border-bottom': last}"
              class="border-top placeholder-glow py-2" aria-hidden="true">
              <span class="placeholder placeholder-lg col-3 me-2"></span>
              <span class="placeholder placeholder-lg col-4 me-2"></span>
              <span class="placeholder placeholder-lg col-3"></span>
              <span class="placeholder col-2 me-2"></span>
              <span class="placeholder col-9"></span>
            </div>
          </div>

        </div>
      </section>

    </div>

    <!-- Event statistics-->
    <div *ngIf="this.isEventOwner || !this.event?.hasTargetAmountHidden" class="col-md-4 col-lg-3">

      <div class="card bg-faded-warning border-0 mb-4">
        <div class="card-body text-center">
          <i class="ai-chart fs-1 text-warning d-block mb-3"></i>
          <h3 class="display-4 pb-1 mb-2">{{totalContributionAmount | number: '1.0-0'}} lei</h3>
          <p class="card-text">total contributii</p>
        </div>
      </div>

      <div class="card bg-faded-info border-0 mb-4">
        <div class="card-body text-center">
          <i class="ai-activity fs-1 text-info d-block mb-3"></i>
          <h3 class="display-4 pb-1 mb-2">{{averageContributionAmount | number: '1.0-0'}} lei</h3>
          <p class="card-text">contributie medie</p>
        </div>
      </div>

      <div *ngIf="targetAmount" class="card bg-faded-success border-0 mb-4">
        <div class="card-body text-center">
          <i class="ai-target fs-1 text-success d-block mb-3"></i>
          <h3 class="display-4 pb-1 mb-2">{{targetAmount | number: '1.0-0'}} lei</h3>
          <p class="card-text">target eveniment</p>
        </div>
      </div>

    </div>
  </div>
</section>
